import { useSeriesId } from '@/hooks';
import { useAppSelector } from '@/store/hooks';
import { useGetSavedQuery } from '@/features/query-builder/savedQueriesApiSlice';
import { selectChartConfigurationHasChanged } from '@/features/query-builder/queryBuilderSlice';

export const useHasSavedQueryChanged = () => {
  const seriesId = useSeriesId();
  const { data: selectedView } = useGetSavedQuery();
  const chartConfigHasChanged = useAppSelector(
    selectChartConfigurationHasChanged,
  );

  const stepsHaveChanged = selectedView && !seriesId;
  return stepsHaveChanged || chartConfigHasChanged;
};
